/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Youtube_HintInputs */

const en_us2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens YouTube`)
};

const pt_br2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre no YouTube`)
};

const es_419_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se abre en YouTube`)
};

const pt_pt2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre no YouTube`)
};

const fr_fr2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvre YouTube`)
};

const de_de2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnet YouTube`)
};

const it_it2_exercise_sheet_youtube_hint = /** @type {(inputs: Exercise_Sheet_Youtube_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apre YouTube`)
};

/**
* | output |
* | --- |
* | "Opens YouTube" |
*
* @param {Exercise_Sheet_Youtube_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_youtube_hint = /** @type {((inputs?: Exercise_Sheet_Youtube_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Youtube_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_youtube_hint(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_youtube_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_youtube_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_youtube_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_youtube_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_youtube_hint(inputs)
	return en_us2_exercise_sheet_youtube_hint(inputs)
});
export { exercise_sheet_youtube_hint as "exercise-sheet.youtube_hint" }